/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Job_OffersInputs */

const cs_nav_job_offers = /** @type {(inputs: Nav_Job_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídky`)
};

const sk_nav_job_offers = /** @type {(inputs: Nav_Job_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponuky`)
};

const en_nav_job_offers = /** @type {(inputs: Nav_Job_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Offers`)
};

/**
* | output |
* | --- |
* | "Job Offers" |
*
* @param {Nav_Job_OffersInputs} inputs
* @param {{ locale?: "cs" | "sk" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_job_offers = /** @type {((inputs?: Nav_Job_OffersInputs, options?: { locale?: "cs" | "sk" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Job_OffersInputs, { locale?: "cs" | "sk" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "cs") return cs_nav_job_offers(inputs)
	if (locale === "sk") return sk_nav_job_offers(inputs)
	return en_nav_job_offers(inputs)
});